import { SxProps, Box, Typography, Theme } from '@mui/material'

export interface TopTitleProps {
  title: string
  sx?: SxProps<Theme>
}

/**
 * Display a common title for a page.
 */
export const TopTitle = (props: TopTitleProps): JSX.Element => {
  return (
    <Box sx={{ mb: '2rem', ...props.sx }}>
      <Typography variant="h1">{props.title}</Typography>
    </Box>
  )
}
